<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header class="text-h6 font-weight-regular">
        {{ $t('APPS.ITEMS') }}
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-data-table
          :headers="headers"
          :items="apps"
          :items-per-page="10"
          :footer-props="footerProps"
          :options.sync="localOptions"
          :sort-by="sortBy"
          sort-asc
        >
        </v-data-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { mapState } from 'vuex';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';

export default {
  name: 'AppsList',

  props: {
    apps: {
      type: Array,
      default: () => []
    },
    meta: {
      type: Object,
      default: () => ({
        total: 0
      })
    }
  },

  data() {
    return {
      localOptions: {},
      sortBy: 'name',
      footerProps: {
        showFirstLastPage: true,
        itemsPerPageOptions: [10, 50, 100]
      }
    };
  },

  computed: {
    ...mapState(['loading']),

    params() {
      const options = this.localOptions;

      return {
        page: options.page,
        per_page: options.itemsPerPage,
        sort_by: options.sortBy[options.sortBy.length - 1],
        order_by: options.sortDesc[options.sortDesc.length - 1] ? 'desc' : 'asc'
      };
    },

    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('ITEM.NAME'),
          sortable: true,
          value: 'name'
        },
        {
          text: this.$t('TILES.ITEM_GROUP'),
          sortable: true,
          value: 'tiles_group'
        }
      ];
    }
  },

  watch: {
    localOptions: {
      handler() {
        this.refreshData();
      },
      deep: true
    },
    options: {
      handler() {
        this.localOptions.page = 1;
        this.refreshData();
      },
      deep: true
    }
  },

  methods: {
    refreshData() {
      this.$emit('refresh', {
        params: Object.assign({}, this.options, this.params)
      });
    }
  }
};
</script>
